import { render } from "./PositionResultsModal.vue?vue&type=template&id=afb713c6&scoped=true&ts=true"
import script from "./PositionResultsModal.vue?vue&type=script&lang=ts"
export * from "./PositionResultsModal.vue?vue&type=script&lang=ts"

import "./PositionResultsModal.vue?vue&type=style&index=0&id=afb713c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afb713c6"]])

export default __exports__